import React, { useState, useEffect } from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { helpers, dateHelpers } from "../utils";
import { toast } from "react-toastify";

export default function SingleDatePicker(props) {
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    if (props.selected) {
      let parsedDate = props.selected.isValid && props.selected.isValid() ? props.selected.toDate() : moment(props.selected).toDate();
      if (parsedDate) {
        setSelectedDate(parsedDate);
      }
    }
  }, [props.selected]);

  function changeDateSelected(dateChange) {
    if (dateHelpers.verifyDate(dateChange)) {
      const dateMoment = dateChange ? moment(dateChange).toDate() : null;
      setSelectedDate(dateMoment);
      props.onChangeCallback(dateMoment, props.fieldName);
    } else {
      toast.warning("Please enter a valid date")
    }
  }

  return (
    <DatePicker
      className="form-control w-100"
      selected={selectedDate || ""}
      onChange={changeDateSelected}
      onKeyDown={(event) =>
        helpers.onDatePickerKeyDown(event, changeDateSelected)
      }
      minDate={props.minDate ? props.minDate : null}
    />
  );
}